import { useNavigate,Outlet } from 'react-router-dom';

import React from 'react';
import { Carousel, Layout, Image, theme } from 'antd';
import Linenav from '../../components/Linenav';
import Headertop from '../../components/Headertop';
import Nextroute from '../../components/Nextroute';
import Foot from '../../components/Foot/index';
import Aboutimg from '../../assets/images/about01.png';
import './index.scss';
const swiperImages = [Aboutimg];
class investor extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      title:'投资者关系',
      routeitems: [],
      keyRout:'',
      isOpen: false
    }
  }

  
  componentDidMount() {
    document.body.classList.add('sidebar-closed');
  }
  componentDidUpdate() {
    const { isOpen } = this.state;
    const bodyClass = document.body.classList;
    if (isOpen) {
      bodyClass.remove('sidebar-closed');
      bodyClass.add('sidebar-open');
    } else {
      bodyClass.remove('sidebar-open');
      bodyClass.add('sidebar-closed');
    }
  }
  componentWillReceiveProps(nextProps) {
  }
  getRouteitems=(e)=>{
    this.setState({
      routeitems: e
    })
  }
  getKeyrout=(e)=>{
    this.setState({
      keyRout: e
    })
  }
  getOpen = (e) => {
    console.log(e, 'eee');
    this.setState({
      isOpen: e
    })
  }
  getOpens = (e) => {
    const bodyClass = document.body.classList;
    if (e) {
      bodyClass.remove('sidebar-open');
      bodyClass.add('sidebar-closed');
    } else {
      bodyClass.remove('sidebar-closed');
      bodyClass.add('sidebar-open');
    }
  }
  render() {
    return (
      <Layout className='main-container'>
      <div className="sidebar">
        <Linenav getOpen={this.getOpens} />
      </div>
      <div className="page-content">
        <Headertop name={this.state.title} getRouteitems={this.getRouteitems} getKeyrout={this.getKeyrout} getOpen={this.getOpen} />
            <Carousel
              effect="scrollx"
              dots={true}
              dotPosition='right'
              autoplay={false}
              style={{ width: '100%' }}
            >
              {
                swiperImages.map((item, indexs) => {
                  return <div key={indexs}> <Image src={item} preview={false} /></div>
                })
              }
            </Carousel>
          <Nextroute routeitems={this.state.routeitems} keyRout={this.state.keyRout} />
          
          <Outlet/>
        <Foot />
        </div>
      </Layout>
    )
  }
}

export default investor;
